<template>
    <div class="body-card-border-primary container">
        <h2 class="pull-center">Éxito</h2>

        <div class="row">
            <div class="col-sm-12" style="text-align: center">
                <b-icon icon="check-circle" class="icon-size-l icon-green margin-bottom" />

                <!-- <p>Tu cuenta se creó correctamente. Te enviamos un correo electrónico de verificación, por favor revisá tu casilla de correo.</p>
                <p>El envío del correo electrónico puede demorar horas, si no lo ves en tu bandeja de entrada, verificá el correo no deseado.</p> -->
                <p>¡Felicidades! Tu cuenta se creó correctamente. Ahora podés empezar a disfrutar de todas las funcionalidades y beneficios disponibles.</p>
                <p>Gracias por elegir Dolar Info 💜</p>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 pull-right">
                <button class="btn-primary" type="submit" v-on:click="goBack()">Inicio</button>
            </div>
        </div>
    </div>
</template>

<script>
import "@/assets/style.css"

export default {
    data() {
        return { }
    },

    async created() { },

    methods: {
        goBack() {
            window.location.href = "/";
        }
    }
}
</script>